import logOutIcon from "../../images/logout_black.svg"
import { useAuthentication } from "../../contexts/UserProvider"

export function LogOut(){
    const {logOut} = useAuthentication();

    return <img src={logOutIcon} onClick={logOut} className="logOut"></img>
}